import React from 'react';

import { useIntl } from 'react-intl-next';

import { cssMap } from '@atlaskit/css';
import Image from '@atlaskit/image/image';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { Text } from '@atlaskit/primitives/compiled/text';
import { token } from '@atlaskit/tokens';

import errorImageDark from '../assets/errorImageDark.svg';
import errorImageLight from '../assets/errorImageLight.svg';
import messages from './inferredProjectCardMessages';

const styles = cssMap({
	panel: {
		display: 'flex',
		alignItems: 'center',
		gap: token('space.200'),
		backgroundColor: token('elevation.surface.sunken'),
		borderRadius: token('radius.large'),
		paddingBlockStart: token('space.250'),
		paddingBlockEnd: token('space.250'),
		paddingInlineStart: token('space.200'),
		paddingInlineEnd: token('space.200'),
	},
	illustration: {
		width: '72px',
		flexShrink: 0,
	},
});

export const InferredProjectCardError = (): React.JSX.Element => {
	const { formatMessage } = useIntl();
	return (
		<Box xcss={styles.panel} role="status" aria-atomic="true">
			<Box xcss={styles.illustration}>
				<Image src={errorImageLight} srcDark={errorImageDark} alt="" role="presentation" />
			</Box>
			<Stack space="space.050">
				<Text size="small" weight="medium" color="color.text.subtlest">
					{formatMessage(messages.hydrationErrorTitle)}
				</Text>
				<Text size="small" color="color.text.subtlest">
					{formatMessage(messages.hydrationErrorDescription)}
				</Text>
			</Stack>
		</Box>
	);
};
